var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IT",
    transform: "translate(21612 -2786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21612 2786)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_66",
    "data-name": "Union 66",
    d: "M34,44a2,2,0,0,1-2-2V38h5a4,4,0,0,0,4-4V7a4.005,4.005,0,0,0-4-4H32V2a2,2,0,0,1,2-2H48a2,2,0,0,1,2,2V42a2,2,0,0,1-2,2Zm10-8.5A1.5,1.5,0,1,0,45.5,34,1.5,1.5,0,0,0,44,35.5Zm0-6A1.5,1.5,0,1,0,45.5,28,1.5,1.5,0,0,0,44,29.5ZM9.5,44a1.5,1.5,0,1,1,0-3h19a1.5,1.5,0,0,1,0,3Zm4.051-3A1.493,1.493,0,0,0,15,39.5V38h8v1.5A1.5,1.5,0,0,0,24.418,41v0ZM2,35a2,2,0,0,1-2-2V8A2,2,0,0,1,2,6H36a2,2,0,0,1,2,2V33a2,2,0,0,1-2,2Zm13.928-7.571h1.749l4.357-12.853H20.285Zm7.3-7.715,4.724,1.651-4.724,1.674v2.269l7.081-2.975V20.422l-7.081-2.967ZM8,20.414v1.919L15,25.3V23.023l-4.634-1.633L15,19.723V17.447Z",
    transform: "translate(-21592 2809)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/IT.11875059.svg";
export { ForwardRef as ReactComponent };